var map = {
	"./AUD.svg": "6nCx",
	"./BRL.svg": "3uLE",
	"./BTC.svg": "1hDg",
	"./CAD.svg": "YdFz",
	"./CHF.svg": "nCce",
	"./CNY.svg": "0WQ/",
	"./ETH.svg": "H33t",
	"./EUR.svg": "1VgR",
	"./GBP.svg": "0gdt",
	"./INR.svg": "VcbP",
	"./JPY.svg": "70AI",
	"./KRW.svg": "oKA0",
	"./LTC.svg": "aKIe",
	"./NZD.svg": "D1+S",
	"./RUB.svg": "VesQ",
	"./USD.svg": "CMZQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sEmZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currencies ^\.\/.*\.svg$
// module id = sEmZ
// module chunks = 14